export const recurrenceLabels = {
	deadline: 'Deadline',
	day: 'Daily',
	week: 'Weekly',
	month: 'Monthly',
	year: 'Yearly'
}
